import { FunctionComponent } from 'react';
import { LinkButton } from '../link/LinkButton';

interface BulkActionHeaderProps<B extends object> {
  dataIdGenerator: (dataId: string) => string;
  selectedItems: Set<string | number>;
  totalCount: number;
  onAllItemsSelectionChange: (selection: boolean) => void;
  BulkActionsComponent?: FunctionComponent<B>;
  bulkActionsComponentProps?: B;
  entity: string;
}

export function BulkActionHeader<B extends object>({
  dataIdGenerator,
  selectedItems,
  totalCount,
  onAllItemsSelectionChange,
  BulkActionsComponent,
  bulkActionsComponentProps,
  entity
}: BulkActionHeaderProps<B>) {
  return (
    <td className='d-flex align-items-center' data-id={dataIdGenerator('bulk-selection-header')}>
      <div className='text-secondary'>{selectedItems.size} selected </div>

      {selectedItems.size !== totalCount ? (
        <LinkButton
          dataId={dataIdGenerator('bulk-select-all')}
          className='ml-3'
          onClick={() => onAllItemsSelectionChange(true)}
        >
          Select {totalCount} {entity}(s) from All Pages
        </LinkButton>
      ) : null}

      {selectedItems.size > 0 ? (
        <LinkButton
          dataId={dataIdGenerator('bulk-clear-all')}
          className='ml-3'
          color='error'
          onClick={() => {
            onAllItemsSelectionChange(false);
          }}
        >
          Clear Selection
        </LinkButton>
      ) : null}

      {BulkActionsComponent && selectedItems.size > 0 ? (
        <div className='ml-3'>
          <BulkActionsComponent {...(bulkActionsComponentProps as B)} />
        </div>
      ) : null}
    </td>
  );
}
